import React from 'react';

import { Messages } from '../../../../../codegen/Localize';
import { FormikTextBox } from '../../../../../commonInfra/components/FormikField';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { narrowTextFieldStyle } from '../../../../styles/CommonStyles';
import { columnFlex } from '../../../styles/ManageUsersStyles';
import { LicenseMaxCounts } from './ManageUsersAdminsOption';
import { ManageUsersSectionProps } from './ManageUsersSection';
import { useQuotaValidator } from './ManageUsersSiteUserQuotaOption';

export const CREATOR_QUOTA_FIELD = 'settings.tierCreatorCapacity';
export const EXPLORER_QUOTA_FIELD = 'settings.tierExplorerCapacity';
export const VIEWER_QUOTA_FIELD = 'settings.tierViewerCapacity';

export function ManageUsersSiteRoleQuotaOption(props: ManageUsersSectionProps & { maxCounts: LicenseMaxCounts }) {
  const formik = useFormikContext<ManageUsersSectionProps>();

  const disabled = !formik.values.settings.siteAdminsCanAddUsers;

  const validateCreator = useQuotaValidator(disabled,
    props.siteInfo.creatorCount, Messages.userLimitMustBeGreaterThanUserCount_creator,
    props.maxCounts?.tierCreatorCountMax ?? Number.MAX_VALUE, Messages.userLimitMustBeLessThanLicenseCount_creator,
  );

  const validateExplorer = useQuotaValidator(disabled,
    props.siteInfo.explorerCount, Messages.userLimitMustBeGreaterThanUserCount_explorer,
    props.maxCounts?.tierExplorerCountMax ?? Number.MAX_VALUE, Messages.userLimitMustBeLessThanLicenseCount_explorer
  );

  const validateViewer = useQuotaValidator(disabled,
    props.siteInfo.viewerCount, Messages.userLimitMustBeGreaterThanUserCount_viewer,
    props.maxCounts?.tierViewerCountMax ?? Number.MAX_VALUE, Messages.userLimitMustBeLessThanLicenseCount_viewer
  );

  const commonProps = {
    maxLength: 8,
    disabled,
    disableOnSubmit: true,
    className: narrowTextFieldStyle
  };

  return <>
    <div>{Messages.siteRoleLimit()}</div>
    {formik.values.settings.userQuotaMode === 'site-tiered-capacity' &&
    <div className={columnFlex}>
      <div>{Messages.siteRoleLimitDescription()}</div>
      <FormikTextBox testId={'tier-creator-capacity-input'}
                     name={CREATOR_QUOTA_FIELD}
                     label={Messages.creators()}
                     validate={validateCreator}
                     value={formik.values.settings.tierCreatorCapacity ?? ''}
                     {...commonProps}
      />
      <FormikTextBox testId={'tier-explorer-capacity-input'}
                     name={EXPLORER_QUOTA_FIELD}
                     label={Messages.explorers()}
                     validate={validateExplorer}
                     value={formik.values.settings.tierExplorerCapacity ?? ''}
                     {...commonProps}
      />
      <FormikTextBox testId={'tier-viewer-capacity-input'}
                     name={VIEWER_QUOTA_FIELD}
                     label={Messages.viewers()}
                     validate={validateViewer}
                     value={formik.values.settings.tierViewerCapacity ?? ''}
                     {...commonProps}
      />
    </div>}
  </>;
}
